export default __webpack_public_path__ + "static/media/007.93aec55e.jpg";